export function archivedSavedDocument(result, document, updateDocRef) {
  const saved = result?.document;
  if (result?.success !== true || !saved?.archivedQa || saved.document_id !== document.document_id) {
    throw new Error('Archived QA did not confirm the saved document. Your edits remain in the tool.');
  }
  if (updateDocRef) updateDocRef.current = saved;
  return saved;
}

// React renders a boolean child as empty. Keep the stored/editable value typed
// while making retained boolean values visible in the archived review.
export const archivedQaDisplayValue = (value, document) => document?.archivedQa && typeof value === 'boolean' ? String(value) : value;
export const archivedQaValueIsEmpty = (value, document) => document?.archivedQa ? value === undefined || value === null || value === '' : !value;

export async function finalizeArchivedPreviewSave(result, { document, scratchPad, clientSubNumber, extractValue, xlType, notifyCount, save, prepareWorkbook }) {
  if (!document?.archivedQa) return result;
  const draft = archivedSavedDocument(result, document);
  if (['sov', 'loss run'].includes(String(xlType || draft.inputFileType || '').toLowerCase())) throw new Error('Save transformed-source changes through the mapping editor. The current QA result was preserved.');
  const prepared = await prepareWorkbook(result.workbookPath, result.jsonPath, undefined, draft, xlType || 'Generic');
  if (prepared?.success !== true || !prepared.jobId) throw new Error('The edited QA workbook was not confirmed. Your current result was preserved.');
  const saved = await save(draft, scratchPad, clientSubNumber, 'QA In Progress', extractValue, xlType, { notifyCount, reviewJobId: prepared.jobId });
  const current = archivedSavedDocument(saved, draft);
  return { ...result, ...saved, jsonPath: current.jsonExtractpath, document: current };
}
